import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import * as ArticleActions from '../../core/store/article/article.actions';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../core/store/app.state';
import { Article } from '../../core/models';
import {
  getFeaturedArticle,
  getFirstSevenArticles,
  getSecondFourArticles,
} from '../../core/store/article/article.selectors';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator:
    | MatPaginator
    | undefined;
  resultsLength = 0;
  isLoading = false;
  featuredNewsArticle$: Observable<Article | null> = this.store.pipe(
    select(getFeaturedArticle)
  );
  firstSpotlightNews$: Observable<Article[]> = this.store.pipe(
    select(getFirstSevenArticles)
  );
  secondSpotlightNews$: Observable<Article[]> = this.store.pipe(
    select(getSecondFourArticles)
  );
  constructor(private store: Store<AppState>) {}
  ngOnInit(): void {
    this.store.dispatch(
      ArticleActions.loadArticles({
        page: 1,
        limit: 25,
      })
    );
    // this.store.dispatch(ArticleActions.selectFeaturedArticle());
  }
}
